import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import type { SidebarContextType } from 'types';

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }) => {
  const [sidebar, setSidebar] = useState(<></>);

  const clearSidebar = () => {
    setSidebar(<></>);
  };

  return (
    <SidebarContext.Provider value={{ sidebar, clearSidebar, setSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.any.isRequired,
};
